<template>
    <ValidationObserver
        ref="newFavorite"
        v-slot="{ passes }"
    >
        <BaseDialog
            :showDialog="showDialog"
            headline="lang_LABEL_STATISTIC_ADD_NEW_FILTER"
            :close="closeDialog"
        >
            <template v-slot:dialogText>
                <v-container fluid>
                    <v-row>
                        <v-col>
                            <BaseEditPageTextField 
                                context="LabelStatisticsCreateNewFavoriteDialog"
                                field="FavoriteName"
                                :label="$t('lang_LABEL_STATISTIC_CAPTION_FAVORITE_NAME')"
                                rules="required|statisticsFavoriteNameUnique:getLabelStatisticsFavoriteDropdownValues"
                                :withMargin="false"
                                noDataText="lang_LABEL_STATISTIC_NO_FILTER"
                                :alvqa="alvqa + '-textfield-favorit-name'"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </template>
            <template v-slot:dialogActions>
                <v-container fluid>
                    <v-row>
                        <v-spacer></v-spacer>
                        <v-col class="text-right">
                            <BaseButton 
                                @click="passes(saveFavorite)"
                                label="lang_LABEL_STATISTIC_ADD_NEW_FILTER"
                                :alvqa="alvqa + '-button-add'"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </template>
        </BaseDialog>
    </ValidationObserver>
</template>

<script>
import BaseDialog from '@/components/_base/BaseDialog'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'

export default {
    name: "LabelStatisticsCreateNewFavoriteDialog",
    components: {
        BaseDialog,
        BaseButton,
        BaseEditPageTextField
    },
    data() {
        return {
            alvqa: "label-statistics-create-new-favorite-dialog",
        }
    },
    computed: {
        showDialog: {
            get() { return this.$store.getters.getShowLabelStatisticsCreateNewFavoriteDialog },
            set(value) { this.$store.commit('setShowLabelStatisticsCreateNewFavoriteDialog', value) }
        },
        favoritName: {
            get() { return this.$store.getters.getLabelStatisticsCreateNewFavoriteDialogDetailsFavoriteName },
            set(value) { this.$store.commit('setLabelStatisticsCreateNewFavoriteDialogDetailsFavoriteName', value) }
        }
    },
    methods: {
        closeDialog() {
            this.showDialog = false
            this.favoritName = null
            this.$store.commit('setSelectedLabelStatisticsFavorite', null)
            this.$store.dispatch('fetchLabelStatisticsFavoriteDropdownValues')
            this.$refs.newFavorite.reset()
        },
        async saveFavorite() {
            const saved = await this.$store.dispatch('saveNewLabelStatisticsFavorite')
            if (!saved) return
            this.$store.commit('setShowLabelStatisticsCreateNewFavoriteDialog', false)
            this.closeDialog()
        }
    }
}
</script>